/**
 * Header search modal — old React Header/SearchResults parity:
 * empty state = popular collections; typing = live grouped results
 * (collections, pages, colours + Shopify product suggestions).
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('ll-search-modal');
    if (!modal) return;

    var overlay = document.getElementById('ll-search-overlay');
    var closeBtn = document.getElementById('ll-search-close');
    var input = document.getElementById('ll-search-input');
    var form = document.getElementById('ll-search-form');
    var popular = document.getElementById('ll-search-popular');
    var resultsEl = document.getElementById('ll-search-results');
    var triggers = document.querySelectorAll('[data-ll-search-trigger]');

    var i18n = parseJson('ll-search-i18n', {});
    var index = parseJson('ll-search-index', { collections: [], pages: [], colors: [] });
    var localItems = []
      .concat(index.collections || [])
      .concat(index.pages || [])
      .concat(index.colors || []);

    var predictiveBase = modal.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = modal.getAttribute('data-search-url') || '/search';
    var debounceTimer = null;
    var abortController = null;
    var lastQuery = '';

    function parseJson(id, fallback) {
      var el = document.getElementById(id);
      if (!el) return fallback;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return fallback;
      }
    }

    function normalize(text) {
      return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function highlight(text, words) {
      var out = escapeHtml(text || '');
      words
        .filter(function (w) { return w.length > 1; })
        .sort(function (a, b) { return b.length - a.length; })
        .forEach(function (word) {
          var re = new RegExp('(' + word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
          out = out.replace(re, '<mark>$1</mark>');
        });
      return out;
    }

    function scoreItem(item, query, words) {
      var title = normalize(item.title);
      var hay = normalize([item.title, item.description, item.keywords].filter(Boolean).join(' '));
      var score = 0;
      if (title === query) score += 100;
      else if (title.indexOf(query) === 0) score += 50;
      else if (title.indexOf(query) !== -1) score += 30;
      if (hay.indexOf(query) !== -1) score += 20;
      words.forEach(function (word) {
        if (title.indexOf(word) !== -1) score += 10;
        else if (hay.indexOf(word) !== -1) score += 4;
      });
      return score;
    }

    function searchLocal(query) {
      var q = normalize(query);
      var words = q.split(' ').filter(function (w) { return w.length > 1; });
      if (!q) return [];
      return localItems
        .map(function (item) {
          return Object.assign({}, item, { score: scoreItem(item, q, words) });
        })
        .filter(function (item) { return item.score >= 8; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 16);
    }

    function predictiveUrl(query) {
      var base = predictiveBase;
      if (base.indexOf('.json') === -1) base += '.json';
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      return (
        base +
        sep +
        'q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last'
      );
    }

    function fetchProducts(query) {
      if (abortController) abortController.abort();
      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      return fetch(predictiveUrl(query), {
        signal: abortController ? abortController.signal : undefined,
        headers: { Accept: 'application/json' },
      })
        .then(function (res) { return res.ok ? res.json() : {}; })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          return products.map(function (p) {
            var img = p.image || p.featured_image;
            var imgUrl = typeof img === 'string' ? img : img && (img.url || img.src);
            var price = p.price;
            if (price && typeof price === 'object') {
              price = price.amount != null ? price.amount : '';
            }
            return {
              type: 'product',
              title: p.title,
              description: p.product_type || '',
              url: p.url,
              price: price,
              image: imgUrl,
              score: 40,
            };
          });
        })
        .catch(function () { return []; });
    }

    function iconSvg(type) {
      if (type === 'attribute') {
        return '<span class="ll-search-modal__dot" aria-hidden="true"></span>';
      }
      var color = type === 'product' ? '#CFA962' : '#64475E';
      return (
        '<svg class="ll-search-modal__result-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="' +
        color +
        '" stroke-width="2" aria-hidden="true"><path d="M12 3l1.8 5.4H19l-4.4 3.2 1.7 5.4L12 14.8 7.7 17l1.7-5.4L5 8.4h5.2z"/></svg>'
      );
    }

    function renderGroup(label, items, words) {
      if (!items.length) return '';
      var html = '<div class="ll-search-modal__group"><p class="ll-search-modal__group-title">' + escapeHtml(label) + '</p>';
      items.forEach(function (item) {
        html +=
          '<a class="ll-search-modal__result" href="' +
          escapeHtml(item.url) +
          '">' +
          (item.image
            ? '<img class="ll-search-modal__thumb" src="' + escapeHtml(item.image) + '" alt="" width="40" height="40">'
            : iconSvg(item.type)) +
          '<span class="ll-search-modal__result-copy">' +
          '<span class="ll-search-modal__result-title">' +
          highlight(item.title, words) +
          '</span>' +
          (item.description
            ? '<span class="ll-search-modal__result-desc">' + highlight(item.description, words) + '</span>'
            : '') +
          '</span>' +
          (item.price ? '<span class="ll-search-modal__result-price">' + escapeHtml(String(item.price)) + '</span>' : '') +
          '</a>';
      });
      html += '</div>';
      return html;
    }

    function render(query, localHits, products) {
      var words = normalize(query).split(' ').filter(function (w) { return w.length > 1; });
      var collections = localHits.filter(function (i) { return i.type === 'collection'; }).slice(0, 6);
      var pages = localHits.filter(function (i) { return i.type === 'page'; }).slice(0, 5);
      var colors = localHits.filter(function (i) { return i.type === 'attribute'; }).slice(0, 6);
      var total = products.length + collections.length + pages.length + colors.length;

      if (!total) {
        resultsEl.innerHTML =
          '<div class="ll-search-modal__empty">' +
          '<p>' + escapeHtml(i18n.noResults || 'No results found') + '</p>' +
          '<p class="ll-search-modal__empty-hint">' + escapeHtml(i18n.tryDifferent || '') + '</p>' +
          '<p class="ll-search-modal__empty-examples">' + escapeHtml(i18n.examples || '') + '</p>' +
          '</div>';
        return;
      }

      var html =
        '<p class="ll-search-modal__count">' +
        escapeHtml(i18n.results || 'Results') +
        ' (' +
        total +
        ')</p>';
      html += renderGroup(i18n.products || 'Products', products, words);
      html += renderGroup(i18n.collections || 'Collections', collections, words);
      html += renderGroup(i18n.pages || 'Pages', pages, words);
      html += renderGroup(i18n.colors || 'Colors', colors, words);
      html +=
        '<a class="ll-search-modal__view-all" href="' +
        escapeHtml(searchUrl) +
        '?q=' +
        encodeURIComponent(query) +
        '">' +
        escapeHtml(i18n.viewAll || 'View all results') +
        '</a>';
      resultsEl.innerHTML = html;
    }

    function runSearch(query) {
      var trimmed = (query || '').trim();
      lastQuery = trimmed;
      if (!trimmed) {
        popular.hidden = false;
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        return;
      }
      popular.hidden = true;
      resultsEl.hidden = false;
      var localHits = searchLocal(trimmed);
      render(trimmed, localHits, []);
      fetchProducts(trimmed).then(function (products) {
        if (lastQuery !== trimmed) return;
        render(trimmed, localHits, products);
      });
    }

    function openSearch(e) {
      if (e) e.preventDefault();
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        if (input) input.focus();
      }, 40);
    }

    function closeSearch(e) {
      if (e && e.currentTarget && e.currentTarget.tagName !== 'A') {
        e.preventDefault();
      }
      modal.hidden = true;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (input) input.value = '';
      runSearch('');
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (overlay) overlay.addEventListener('click', closeSearch);
    modal.querySelectorAll('[data-ll-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeSearch();
    });

    if (input) {
      input.addEventListener('input', function () {
        var value = input.value;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          runSearch(value);
        }, 160);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var q = (input && input.value || '').trim();
        if (!q) e.preventDefault();
      });
    }

    modal.querySelectorAll('.ll-search-modal__popular-list a').forEach(function (link) {
      link.addEventListener('click', closeSearch);
    });
    resultsEl.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a) closeSearch();
    });
  });
})();
